import React from 'react';

interface Props {
  errorsByType: Record<string, number>;
}

const TYPE_CONFIG: Record<string, { label: string; color: string; emoji: string }> = {
  format: { label: 'Format', color: 'bg-green-400', emoji: '' },
  parsing: { label: 'Parsing', color: 'bg-yellow-400', emoji: '' },
  ocr: { label: 'OCR', color: 'bg-orange-400', emoji: '' },
  omission: { label: 'Omission', color: 'bg-yellow-500', emoji: '' },
  hallucination: { label: 'Hallucination', color: 'bg-red-500', emoji: '' },
};

export const ErrorTypesPie: React.FC<Props> = ({ errorsByType }) => {
  const total = Object.values(errorsByType).reduce((a, b) => a + b, 0);

  if (total === 0) {
    return (
      <div className="bg-white p-4 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4">Repartition des erreurs</h3>
        <p className="text-gray-500 text-center py-8">Aucune erreur detectee</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-4 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4">Repartition des erreurs</h3>
      <div className="space-y-2">
        {Object.entries(errorsByType).map(([type, count]) => {
          const config = TYPE_CONFIG[type] || { label: type, color: 'bg-gray-400', emoji: '' };
          const percentage = ((count / total) * 100).toFixed(0);

          return (
            <div key={type} className="flex items-center gap-2">
              <span>{config.emoji}</span>
              <span className="w-24 text-sm">{config.label}</span>
              <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className={`h-full ${config.color}`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
              <span className="w-12 text-right text-sm">{percentage}%</span>
              <span className="w-10 text-right text-xs text-gray-500">({count})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
